import {useContext, useState} from 'react'
import {HomeContext} from '../../../context/HomeContext.jsx'
import {getLocal, removeLocal, setLocal} from '../../../hooks/useStorage/useStorage.jsx'
import {general as textsGeneral} from '../../../translate/Translate.jsx'
import moment from 'moment'
import QRCode from 'qrcode.react'

import Button from '../../../components/button/Button.jsx'
import {getLog, sendLog} from '../../../services/Apis.jsx'
import {copy} from 'react-lf-tools'

import './trackOrder.scss'

const TrackOrder = ({status, onMessage}) => {
    if (!status) return
    const {isCartButton} = useContext(HomeContext)
    const orderOld = getLocal('orderOld', {})
    const [timeLeft, setTimeLeft] = useState('')

    const checkIdentify = () => {
        if (!status?.identificacao) return

    }

    const checkPIX = () => {
        if (!status?.qrcode) return
        const id = getLocal('intervalID', '')
        if (!!id) return
        const intervalID = setInterval(async () => {
            const currentTime = moment()
            const expirationTime = moment(orderOld.expire)
            if (expirationTime.isBefore(currentTime)) {
                cancelPix()
            } else {
                const duration = moment.duration(expirationTime.diff(currentTime))
                const minutes = Math.floor(duration.asMinutes())
                const seconds = duration.seconds()
                const time = `${minutes}:${String(seconds).padStart(2, '0')}`
                setTimeLeft(time)
            }
        }, 1000)
        setLocal('intervalID', intervalID)
    }

    const requestLog = (orderOld) => JSON.stringify({
        pedido: {
            authkey: import.meta.env.VITE_AUTHKEY,
            id_pedido: orderOld.id_pedido,
            retorno: {
                status: 'CANCELADO',
                mensagem: 'Pedido cancelado falta de pagamento!'
            }
        }
    })

    const cancelPix = async () => {
        const {returnCode, data: {pedido: {retorno: {status}}}} = await getLog(orderOld.id_pedido)
        if ((returnCode === 1 && (status === 'PIX'))) {
            const request = requestLog(orderOld)
            await sendLog(request, 'PUT')
        }
        console.log('cancelado')
        setTimeLeft('0:00')
        const intervalID = getLocal('intervalID', '')
        clearInterval(intervalID)
        removeLocal('intervalID')
        removeLocal('orderOld')
        window.location.reload()
    }

    switch (status.status) {
        case 'CONFIRMADO':
            checkPIX()
            checkIdentify()
            break
    }

    const handleClick = async (value) => {
        const result = await copy(value)
        onMessage(result)
    }

    const handleCancel = () => cancelPix()

    if (!status.status) return null

    if ((!!status.qrcode && !isCartButton)) return <div className={'track-order'}>
        <div className={'div-pix'}>
            <>
                <div className={'div-qrcode'}>
                    <QRCode className={'qrcode'} value={status?.qrcode || ''}/>
                </div>
                <Button
                    value={status.mensagem}
                    className={'button-copy'}
                    title={textsGeneral.copyPix}
                    onClick={handleClick}
                />
                <Button
                    value={status.mensagem}
                    variant={'text'}
                    className={'button-cancel'}
                    title={textsGeneral.cancelPix}
                    onClick={handleCancel}
                />
            </>
            <label className={'warning-payment'}>
                {textsGeneral.pixPaymentNotice}
            </label>
            <div className={'div-infos'}>
                <div>
                    <label>
                        {`N° #${orderOld.id_pedido.slice(-4)}`}
                    </label>
                </div>
                {(orderOld?.total_produtos) && <div>
                    <label>
                        {(orderOld?.total_produtos || 0).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                    </label>
                </div>}
                <div>
                    <label>
                        {timeLeft}
                    </label>
                </div>
            </div>
        </div>
    </div>

    if ((!!status.identificacao && !isCartButton)) return <div className={'track-order'}>
        <div className={'div-identify'}>
            <label className={'text'}>
                Fique atento!!!
            </label>
            <label className={'text'}>
                Quando seu pedido estiver pronto você será chamado pela identificação abaixo
            </label>
            <label className={'title'}>
                {status.identificacao}
            </label>
        </div>
    </div>

}

export default TrackOrder
